//extended by fsVideo.js
//provides ability to pin or dock video on lower right

import Viewports from '../../components/fsUtils/Viewports';

class Pinner {

    constructor() {

        this.header = document.querySelector('#body-header-wrapper');
        this.pinPos = (this.header) ? this.header.clientHeight : 45;
        this.resizeEv = undefined;
        this.pinCloseEl = undefined;
        this.pinWrapper = document.querySelector('.fs-pin-wrapper');
        this.isTopPinEnabled = true;
        this.isTopPinEnabled = this.pinWrapper && this.isTopPinEnabled;
        //I dont like multiple wrappers but NEO player is limited for doing video pinning
        this.parentEl = undefined;
        this.grandParentEl = undefined;
        this.parentElWrapper = undefined;
        this.elInfo = undefined;
        this.bodyClassList = document.body.classList;
        this.disableVideoPinning = document.body.classList.contains('disable-video-pinning');
        this.isJWPlayer = document.body.classList.contains('jw-player');

        //using rAF for better scrolling performance - https://www.html5rocks.com/en/tutorials/speed/animations/
        this.latestKnownScrollY = 0;
        this.ticking = false;
        this.isPinned = false;
        this.resetDelay = 400;
        this.viewport = new Viewports();
    }

    startPinning() {
        //enable pinning when attribute is available
        if(!this.disableVideoPinning) {
            this.el.hasAttribute("enable-pinning") && this.enablePinning();
        }

    }

    enablePinning() {

        this.parentEl = this.el.parentElement;
        this.grandParentEl = this.parentEl.parentElement;
        if( this.isTopPinEnabled ) {
            this.parentElWrapper = this.grandParentEl.parentElement;
            this.grandParentEl = this.parentElWrapper.parentElement;
            this.elInfo = this.grandParentEl.querySelector('.fs-video-details');
        }

        this.startScroll();
    }

    //using rAF for better scrolling performance - https://www.html5rocks.com/en/tutorials/speed/animations/
    startScroll() {
        window.addEventListener("scroll", function(ev) {
            this.requestTick();
        }.bind(this));
    }

    //udpate method for rAf - see above
    requestTick() {
        if (!this.ticking) {
            requestAnimationFrame(this.onScrollUpdate.bind(this));
        }
        this.ticking = true;
    }

    onScrollUpdate() {

        //for rAF scroll optimization - https://www.html5rocks.com/en/tutorials/speed/animations/
        this.ticking = false;
        //determine scroll direction
        let newScrollY = window.scrollY;
        let scrollDir = (newScrollY < this.latestKnownScrollY - 1) ? "up" : "down";
        let isVisible = this.viewport.isElmInViewport(this.grandParentEl);
        
        if (!isVisible && !this.isPinned && !this.isFullScreen) {
            (this.isPlaying || (this.isJWPlayer && !this.player.paused)) && this.pin(this.parentEl);
        } //logic to pin when scrolling down 
        if (isVisible && this.isPinned || this.isPinned && this.isFullScreen) {
            this.unpin(this.parentEl);
        }

        this.latestKnownScrollY = newScrollY;
    }

    //for pinned state reserving space
    retainSize(el) {

        var rect = el.getBoundingClientRect();
        var height = rect.height;
        var width = rect.width;

        el.style.cssText = 'height:' + height + 'px;' + 'width:' + width + 'px;';

    }

    clearRetainSize(el) {
        el.style.cssText = '';
    }

    onPinClose() {
        this.fngPlayer ? this.player.pause() : this.pause();
        this.unpin(this.parentEl);
    }

    createCloseButton() {

        let closeEl = document.createElement('span');
        closeEl.className = this.isTopPinEnabled ? "pin-top pin-close" : "pin-close";
        closeEl.innerHTML = "&#x2715;";
        closeEl.addEventListener("click", this.onPinClose.bind(this));

        return closeEl;
    }

    addCloseButton() {
        this.pinCloseEl = this.pinCloseEl || this.createCloseButton();
        this.isTopPinEnabled ? 
            this.parentElWrapper.appendChild( this.pinCloseEl) : this.parentEl.appendChild(this.pinCloseEl);

    }

    removeCloseButton() {
        this.isTopPinEnabled ? this.parentElWrapper.removeChild(this.pinCloseEl) : this.parentEl.removeChild(this.pinCloseEl);
    }

    pin(el) {

        this.retainSize(this.grandParentEl);

        el.classList.remove('unpin-player');
        el.classList.add('pin-player');
        if(  this.isTopPinEnabled ) {
            this.bodyClassList.add('player-pinned');
            let wrapper = el.parentElement.parentElement;
            wrapper.classList.add('pin-player');
            wrapper.classList.add('fade-in');
        }
  
        //temporary remove later
        this.hackGalleryParentZIndex(true);

        this.resetSize();
        this.addCloseButton();

        this.isPinned = true;

        return el;

    }

    unpin(el) {

        el.classList.remove('pin-player');
        if( this.isTopPinEnabled) {
            let wrapper = el.parentElement.parentElement;
            wrapper.classList.remove('pin-player');
            wrapper.classList.remove('fade-in');
            wrapper.classList.add('fade-out');
        } else {
            el.classList.add('unpin-player');
        }

        //temporary remove later
        this.hackGalleryParentZIndex(false);
        //need to reset for safari issue of position fixed to relative;
        setTimeout(() => {
            if( this.isTopPinEnabled )  {
                !this.isPinned && this.bodyClassList.remove('player-pinned');
                el.parentElement.parentElement.classList.remove('fade-out');
            } else {
                el.classList.remove('unpin-player');
            }
            !this.isPinned && this.removeCloseButton();
        }, this.resetDelay)

        this.resetSize();

        this.isPinned = false;

        return el;

    }

    //very temporary hack for gallery fix
    hackGalleryParentZIndex(isPinned) {

        let greatGrandParentEl = this.grandParentEl.parentElement;
        let attrName = 'gallery-image-wrap-id';

        if (greatGrandParentEl.hasAttribute(attrName)) {
            let imgWrapId = greatGrandParentEl.getAttribute(attrName);
            let galleryWrapEl = document.getElementById('gallery-image-wrap-' + imgWrapId);
            //set zindex if pinned
            (isPinned) ? galleryWrapEl.setAttribute('style', 'z-index:4'): galleryWrapEl.removeAttribute('style');
        }

    }


    //NEO recommended dispatchEvent new Event to trigger resize of player
    resetSize(callback) {

        this.resizeEv = (this.resizeEv) ? this.resizeEv : new Event('resize');
        let resizeDelay = this.resetDelay;

        setTimeout(() => {
            //from NEO, this resets the player viewport
            window.dispatchEvent(this.resizeEv);
            (typeof callback === 'function') && callback();
        }, resizeDelay);

    }

}

export default Pinner;


// WEBPACK FOOTER //
// ./assets/components/platformPlayer/Pinner.js